
import { MdVerifiedUser } from 'react-icons/md';
import { AiOutlineInfoCircle } from 'react-icons/ai';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';


const VerifiedBadge = () => {

    return (

        <div className='flex flex-row justify-center items-center relative space-x-1'>

            <div className="flex flex-row justify-center space-x-2 items-center w-[30px] md:w-[84px] h-[28px] px-[5px] py-[9px] bg-white border border-[#0066a0] rounded-[9px]">

                <MdVerifiedUser className='text-[#0066a0] text-[17px]'/>
                <p className='md:flex hidden text-[#0066a0] text-[12px]'>Verified</p>

            </div>

            <div className='ml-[auto] mb-[auto] w-[25px] h-full justify-start items-start hidden md:flex'>

                <Tooltip
                    title={<p className='text-[13px]'>This user has been verified by the AgeMD staff</p>}
                    className='!p-0'
                >
                    <IconButton>
                        <AiOutlineInfoCircle  className='text-gray text-[17px]'/>
                    </IconButton>
                </Tooltip>

            </div>

        </div>
    )

}

export default VerifiedBadge